
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agents",
      function () {
        return require("private-next-pages/agents/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agents"])
      });
    }
  